export const FETCH_BATTERY_LEVEL_REQUEST = '[BatteryLevel] FETCH_BATTERY_LEVEL_REQUEST';
export const FETCH_BATTERY_LEVEL_SUCCESS = '[BatteryLevel] FETCH_BATTERY_LEVEL_SUCCESS';
export const FETCH_BATTERY_LEVEL_FAILURE = '[BatteryLevel] FETCH_BATTERY_LEVEL_FAILURE';
